import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // 👈 добавляем флаг загрузки
  const navigate = useNavigate();

  const redirectByRole = useCallback(
    (role) => {
      if (role === "patient") {
        navigate("/cabinet");
      } else if (role === "operator") {
        navigate("/staff");
      } else if (role === "admin") {
        navigate("/admin");
      }
    },
    [navigate]
  );

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      const parsedUser = JSON.parse(savedUser);
      setUser(parsedUser);
      // ❗️ НЕ редиректим автоматически при F5,
      // оставляем пользователя на текущей странице
    }
    setLoading(false); // 👈 проверка завершена
  }, []);

  const login = (token, role) => {
    const userData = { token, role };
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
    redirectByRole(role); // редиректим только при входе
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    navigate("/login");
  };

  if (loading) {
    return <p>Загрузка...</p>; // пока проверяем токен
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
